import { lazy, Suspense } from 'react';

const LazyMarkdown = lazy(
  () =>
    import(
      /* webpackChunkName: "markdown" */
      /* webpackPrefetch: true */
      './Markdown'
    ),
);

export default function Markdown(props) {
  return (
    <Suspense fallback={null}>
      <LazyMarkdown {...props} />
    </Suspense>
  );
}
